define('v3/Pages/SchoolReport/Services/SchoolReport.Service',[
	'module',
	'jquery',
	'v3/Common/Models/enums',
	'v3/Pages/SchoolReport/Services/SchoolReport.Backend'
], function (module, $, enums, schoolReportBackend) {
	return {
		getSubjectsAndClasses: function () {
			return schoolReportBackend.getSubjectsAndClasses();
		},
		getSchoolProgress: function (subjectCategory, semesterPeriod) {
			return schoolReportBackend.getSchoolProgress(subjectCategory, semesterPeriod);
		},
		getGrowthsOnClassesPerSubjects: function (period, subjectWithClassIdsModels) {
			var periodName = null;

			for (var prop in enums.semesterPeriod) {
				if (enums.semesterPeriod.hasOwnProperty(prop) && enums.semesterPeriod[prop] === period) {
					periodName = prop;
					break;
				}
			}

			if (!periodName) {
				throw new Error('Unknown period value.');
			}

			return this.validateRequest(schoolReportBackend.getGrowthsOnClassesPerSubjects, [period, subjectWithClassIdsModels]);
		},
		getAbilitiesOnClassesOnSubject: function (period, subjectWithClassIdsModel) {
			var periodName = null;
			for (var prop in enums.semesterPeriod) {
				if (enums.semesterPeriod.hasOwnProperty(prop) && enums.semesterPeriod[prop] === period) {
					periodName = prop;
					break;
				}
			}

			if (!periodName) {
				throw new Error('Unknown period value.');
			}

			return this.validateRequest(schoolReportBackend.getAbilitiesOnClassesOnSubject, [period, subjectWithClassIdsModel]);
		},
		goToTeach: function () {
			window.location.href = module.config().actions.goToTeach;
		},
		goToError: function () {
			window.location.href = module.config().actions.goToError;
		},
		validateRequest: function (backendCallback, args) {
			// check if request can be succesfully executed or not
			// if not, the user will be redirected to an error page
			// this is needed for the schoolreport page since it relies heavily on
			// the metrics api. If requests to this api fail the page shouldn't
			// be shown at all
			var self = this;
			var deferred = $.Deferred();

			backendCallback.apply(schoolReportBackend, args)
				.done(function (data) { deferred.resolve(data); })
				.fail(function (response) {
					if (response.status === 401) {
						return;
					}
					deferred.reject();
					self.goToError();
				});

			return deferred;
		}
	};
});
